import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IS_SPINNER_ACTIVE } from '../../../util/interceptors';
import { Profile } from '../dto/Profile';
import { UrlService } from '../../../../environments/urlService';

@Injectable({
  providedIn: 'root',
})
export class CabinetService {
  private url: string;
  private _profile = new BehaviorSubject<Profile>(null);

  constructor(
    private httpClient: HttpClient,
    private urlService: UrlService) {
    this.url = this.urlService.getFmsUrl() + 'profile';
  }

  public updateProfile(profile: Profile): Promise<Profile> {
    return this.httpClient.put<Profile>(this.url, profile, {
      withCredentials: true,
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      responseType: 'json',
    }).toPromise();
  }

  setProfile(profile: Profile): void {
    this._profile.next(profile);
  }

  get profile(): BehaviorSubject<Profile | null> {
    return this._profile;
  }
}
